{
  "customer-request-online-booking-dialog": {
    "buttons": {
      "submit": "SOUMETTRE"
    },
    "text": {
      "title": "Demande de réservation en ligne",
      "email": "Votre email",
      "hint": "Le salon ne propose pas encore la prise de rendez-vous en ligne. Laissez-nous votre adresse e-mail et nous vous préviendrons lorsque la prise de rendez-vous en ligne sera activée pour le salon à l'avenir",
      "request-sent-success": "Votre demande a été envoyée avec succès !"
    }
  }
}
